module.exports = __webpack_public_path__ + "img/model_7.4f3d9c6c.png";